import React, {useRef, useState, useEffect} from "react"

const HotspotInfo = ({ title, subtitle, maker, origin, time, size, image, alt}) => {
    const mountRef = useRef(null);
    const containerRef = useRef(null);
    return (
        <div className="info-container" ref={containerRef}>
            <h2>{title}</h2>
            <h3>{subtitle}</h3>
            <ul>
                <li key={`${title}-1`}>
                    <p>Maker</p>
                    <p>{maker}</p>
                </li>
                <li key={`${title}-2`}>
                    <p>Origin</p>
                    <p>{origin}</p>
                </li>
                <li key={`${title}-3`}>
                    <p>Time</p>
                    <p>{time}</p>
                </li>
                <li key={`${title}-4`}>
                    <p>Size</p>
                    <p>{size}</p>
                </li>
            </ul>
            <img src={image} alt={alt}></img>
        </div>
    )
}

export default HotspotInfo;